<template>
  <v-card>
    <v-card-section>
      <v-card-title>{{ titleAutomaticMode }}</v-card-title>
      <v-card-body v-loading="loading">
        <hr />
        <div class="setting">
          <div class="setting__label">{{ $t('v.settings.labelPlacements') }}</div>
          <div class="setting__control">
            <v-switch-with-popover
              :value="hasPlacementsAutodisable"
              :title="hasPlacementsAutodisableTitle"
              :disabled="!canChangeSettings"
              @change="changeAccountSetting('hasPlacementsAutodisable', $event)"
            />
          </div>
        </div>
      </v-card-body>
    </v-card-section>
  </v-card>
</template>

<script>
import VCardBody from '@/components/common/VCardBody.vue'
import VCardSection from '@/components/common/VCardSection.vue'
import VCard from '@/components/common/VCard.vue'
import VCardTitle from '@/components/common/VCardTitle.vue'
import VSwitchWithPopover from '@/components/common/VSwitchWithPopover.vue'
import * as types from '@/store/types'
import * as authorities from '@/utils/authorities'

export default {
  name: 'VPlacementsAutodisable',
  components: {
    VCardBody,
    VCardSection,
    VCard,
    VCardTitle,
    VSwitchWithPopover
  },
  computed: {
    titleAutomaticMode() {
      return this.$t('v.settings.titleAutomaticMode').toUpperCase()
    },
    hasPlacementsAutodisable() {
      return this.$store.state[types.ACCOUNT_SETTINGS].model.hasPlacementsAutodisable
    },
    hasPlacementsAutodisableTitle() {
      const actionTextEnable = this.$t(
        'v.settings.popoverTitleEnableStoppingPlacements'
      )
      const actionTextDisable = this.$t(
        'v.settings.popoverTitleDisableStoppingPlacements'
      )
      return this.hasPlacementsAutodisable
        ? actionTextDisable
        : actionTextEnable
    },
    canChangeSettings() {
      return this.$store.getters.hasAuthorities(authorities.CHANGE_SETTINGS)
    },
    loading() {
      return this.$store.state[types.ACCOUNT_SETTINGS].loading
    }
  },
  methods: {
    changeAccountSetting(setting, value) {
      this.$store.dispatch(types.CHANGE_ACCOUNT_SETTING, { setting, value })
    }
  }
}
</script>

<style lang="scss">
</style>
